import * as types from '../types';

export default {
  [types.GET_COMPACT_LIST](state, data) {
    state.compactData = data;
  },
  [types.GET_COMPACT_COUNT](state, data) {
    state.compactCount = data;
  },
  [types.GET_COMPACT_TYPE_LIST](state, data) {
    state.compactType = data.results;
  },
  [types.GET_SERVICE_CONTENT_LIST](state, data) {
    state.serviceContent = data.results;
  },
  [types.GET_SETTLEMENT_TYPE_LIST](state, data) {
    state.settlementType = data.results;
  },
  [types.GET_BUSI_SELECT_DATA](state, data) {
    state.busiSelectData = data;
  },
  [types.GET_COMPACT_CUSTOM_SELECT_DATA](state, data) {
    state.customSelectData = data;
  },
  [types.GET_COMPACT_DETAIL](state, data) {
    state.compactDetail = data;
  },
  [types.GET_COMPACT_RETURND_RECORD](state, data) {
    state.returndRecord = data;
  },
  [types.GET_COMPACT_RETURND_RECORD_DETAIL](state, data) {
    state.returndRecordDetail = data;
  },
  [types.GET_COMPACT_BILLS_RECORD](state, data) {
    state.billsRecord = data;
  },
  [types.GET_COMPACT_BILLS_RECORD_DETAIL](state, data) {
    state.billsRecordDetail = data;
  },
  [types.GET_COMPACT_FILE_LIST](state, data) {
    state.compactFileData = data;
  },
  [types.GET_COMPACT_COST_LIST](state, data) {
    state.compactCostData = data;
  },
  [types.GET_COMPACT_COST_TYPE](state, data) {
    state.compactCostType = data;
  },
  [types.GET_COPRATION_DEPARTMENT](state, data) {
    state.coprationDepartment = data.results;
  },
  [types.GET_COMPACT_TEAM](state, data) {
    state.compactTeams = data;
  },
  [types.GET_SIGNING_FORM_LIST](state, data) {
    state.signingForm = data;
  },
  [types.GET_COMPACT_SALESMAN](state, data) {
    state.compactSalesman = data.data;
  },
  [types.GET_MONEY_BACK_DATA](state, data) {
    state.moneyBackData = data;
  },
  [types.GET_COST_DATA_LIST](state, data) {
    state.costDataList = data;
  },
  [types.GET_PAY_DATA_LIST](state, data) {
    state.payDataList = data;
  },
  [types.GET_COMPACT_PAY_TYPE](state, data) {
    state.compactPayType = data;
  },
  [types.GET_MONEY_SPEND_DATA](state, data) {
    state.spendDataList = data;
  },
  [types.GET_SPEND_SALES](state, data) {
    state.spendSalesList = data.data;
  },
  [types.GET_SPEND_DETAIL](state, data) {
    state.spendDetail = data;
  },
};
